import { useTranslation } from "../i18n/LanguageContext";

const ExampleLandingHeader = ({ title, items = [], eyebrow }) => {
    const { language, setLanguage, t } = useTranslation();
    const languages = ["it", "en", "de"];

    return (
        <div className="flex flex-col gap-4 md:flex-row md:items-center md:justify-between">
            <div>
                <p className="text-xs font-semibold uppercase tracking-[0.4em] opacity-70">
                    {eyebrow || t("example.eyebrow")}
                </p>
                <h1 className="mt-2 text-3xl font-semibold md:text-5xl">{title}</h1>
            </div>
            <div className="flex flex-col gap-3 sm:flex-row sm:items-center">
                <nav className="flex items-center gap-4 text-xs font-semibold uppercase tracking-widest">
                    {items.map((item) => (
                        <a key={item.href} href={item.href} className="opacity-80 hover:opacity-100">
                            {item.label}
                        </a>
                    ))}
                </nav>
                <div className="flex items-center rounded-full bg-white/80 p-1 text-xs shadow">
                    {languages.map((lang) => (
                        <button
                            key={lang}
                            type="button"
                            onClick={() => setLanguage(lang)}
                            aria-pressed={language === lang}
                            className={`rounded-full px-3 py-1 font-semibold transition ${
                                language === lang
                                    ? "bg-slate-900 text-white"
                                    : "text-slate-700 hover:bg-slate-200"
                            }`}
                        >
                            {lang.toUpperCase()}
                        </button>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default ExampleLandingHeader;
